import React, { FC } from "react";
import Bugsnag from "@bugsnag/js";

interface Props {
  children: any;
}

const BugsnagErrorBoundary =
  Bugsnag.getPlugin("react")?.createErrorBoundary(React);

const ErrorBoundary: FC<Props> = ({ children }) => {
  if (!BugsnagErrorBoundary) return children;

  return <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>;
};

export default React.memo(ErrorBoundary);
